/**
 * Created by shanie on 1/13/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles/DropDown.scss';

class DropDown extends React.Component {
    constructor(props) {
        super(props);

        this.onSelectChange = this.onSelectChange.bind(this);
    }

    onSelectChange(event) {
        this.props.onSelect(event.target.value);
    }

    render() {
        const { defaultSelection, selectOptions, size } = this.props;

        const containerClasses = classnames(styles.container, {
            [styles.fullWidth]: size === 'large',
        });

        return (
            <div className={containerClasses}>
                <BasicSelect
                    dataTn="favorites-sort-by"
                    name="select"
                    options={selectOptions}
                    onChange={this.onSelectChange}
                    size={size}
                    value={defaultSelection}
                />
            </div>
        );
    }
}

DropDown.defaultProps = {
    defaultSelection: '',
    label: '',
    selectOptions: [],
    size: 'small',
    value: '',
};

DropDown.propTypes = {
    defaultSelection: PropTypes.string,
    label: PropTypes.string,
    onSelect: PropTypes.func,
    selectOptions: PropTypes.array,
    size: PropTypes.string,
    value: PropTypes.string,
};

export default DropDown;
